function DocsRender(containerSelector, options) {
    var registry = (typeof window !== 'undefined')
        ? (window.__docs_render_instances = window.__docs_render_instances || {})
        : {};

    function normalizeSelector(value) {
        return String(value || '').trim();
    }

    function sanitizePrefix(value, fallback) {
        var raw = String(value || '').trim();
        if (!raw) {
            raw = String(fallback || 'docs').trim();
        }
        raw = raw.replace(/^#+/, '').replace(/[^a-z0-9_-]+/gi, '-').replace(/-+/g, '-');
        return raw || 'docs';
    }

    function resolveRequestApi() {
        var requestApi = (typeof window !== 'undefined' && window.Request)
            ? window.Request
            : ((typeof Request !== 'undefined') ? Request : null);

        if (!requestApi || !requestApi.http || typeof requestApi.http.post !== 'function') {
            return null;
        }
        return requestApi;
    }

    function getRequestUnavailableMessage() {
        var requestApi = resolveRequestApi();
        if (requestApi && typeof requestApi.getUnavailableMessage === 'function') {
            return requestApi.getUnavailableMessage();
        }
        return 'Servizio comunicazione non disponibile. Ricarica la pagina e riprova.';
    }

    function getErrorMessage(error, fallback) {
        var requestApi = resolveRequestApi();
        if (requestApi && typeof requestApi.getErrorMessage === 'function') {
            return requestApi.getErrorMessage(error, fallback || 'Impossibile caricare il contenuto.');
        }
        if (typeof error === 'string' && error.trim() !== '') {
            return error.trim();
        }
        if (error && typeof error.message === 'string' && error.message.trim() !== '') {
            return error.message.trim();
        }
        return fallback || 'Impossibile caricare il contenuto.';
    }

    function readVisualUrl(value) {
        return (typeof value === 'string') ? value.trim() : '';
    }

    function createSettings(selector, opts) {
        var base = {
            url: null,
            prefix: null,
            label: 'Capitolo',
            subLabel: 'Sottocapitolo',
            emptyText: 'Nessun contenuto disponibile.',
            loadingText: 'Caricamento contenuti...',
            errorText: 'Impossibile caricare il contenuto.',
            cacheResponse: true,
            requestPayload: {},
            viewMode: 'navigation'
        };
        var merged = Object.assign({}, base, opts || {});
        merged.prefix = sanitizePrefix(merged.prefix, selector);
        if (!merged.requestPayload || typeof merged.requestPayload !== 'object') {
            merged.requestPayload = {};
        }
        if (merged.viewMode !== 'monolithic') {
            merged.viewMode = 'navigation';
        }
        return merged;
    }

    function createInstance(selector, opts) {
        var instance = {
            selector: normalizeSelector(selector),
            settings: createSettings(selector, opts),
            mounted: false,
            destroyed: false,
            loading: false,
            loaded: false,
            requestId: 0,
            responseCache: null,
            $container: null,
            $nav: null,
            $content: null,
            $filter: null,
            _filterNs: null,

            buildChapterLabel: function (chapter, chapterKey) {
                var label = chapter.label || (this.settings.label + ' ' + chapterKey);
                if (!chapter.label && chapter.title) {
                    label += ' - ' + chapter.title;
                }
                return label;
            },

            getChapterIconUrl: function (chapter) {
                if (!chapter || typeof chapter !== 'object') {
                    return '';
                }
                var icon = readVisualUrl(chapter.icon);
                if (icon !== '') {
                    return icon;
                }
                return readVisualUrl(chapter.media);
            },

            getChapterMediaUrl: function (chapter) {
                if (!chapter || typeof chapter !== 'object') {
                    return '';
                }
                var media = readVisualUrl(chapter.media);
                if (media !== '') {
                    return media;
                }
                return readVisualUrl(chapter.image);
            },

            createLabelNode: function (label, chapter, options) {
                var iconUrl = this.getChapterIconUrl(chapter);
                var settings = Object.assign({
                    iconSize: '2.4rem',
                    iconBorderRadius: '999px',
                    gap: '0.75rem',
                    textClass: ''
                }, options || {});

                var $text = $('<span></span>').text(label);
                if (settings.textClass) {
                    $text.addClass(settings.textClass);
                }

                if (iconUrl === '') {
                    return $text;
                }

                var $wrap = $('<span class="d-inline-flex align-items-center"></span>').css('gap', settings.gap);
                var $icon = $('<img alt="" aria-hidden="true">');
                $icon.attr('src', iconUrl);
                $icon.css({
                    width: settings.iconSize,
                    height: settings.iconSize,
                    objectFit: 'cover',
                    borderRadius: settings.iconBorderRadius,
                    flexShrink: '0',
                    boxShadow: '0 0 0 1px rgba(255,255,255,.12)'
                });

                $wrap.append($icon);
                $wrap.append($text);
                return $wrap;
            },

            appendChapterBody: function ($target, chapter, bodyClass) {
                if (!$target || !$target.length || !chapter || typeof chapter !== 'object') {
                    return this;
                }

                var bodyHtml = (typeof chapter.body === 'string') ? chapter.body : '';
                var mediaUrl = this.getChapterMediaUrl(chapter);
                if (bodyHtml.trim() === '' && mediaUrl === '') {
                    return this;
                }

                var bodyAlt = readVisualUrl(chapter.media_alt) || readVisualUrl(chapter.label) || readVisualUrl(chapter.title) || 'Illustrazione';
                var $body = $('<div class="docs-chapter-body"></div>').css('display', 'flow-root');
                if (bodyClass) {
                    $body.addClass(bodyClass);
                }

                if (mediaUrl !== '') {
                    var $figure = $('<figure class="docs-chapter-media"></figure>').css({
                        float: 'right',
                        width: 'min(38vw, 240px)',
                        maxWidth: '42%',
                        minWidth: '140px',
                        margin: '0 0 1rem 1.25rem'
                    });
                    var $image = $('<img class="img-fluid" loading="lazy">');
                    $image.attr({
                        src: mediaUrl,
                        alt: bodyAlt
                    });
                    $image.css({
                        width: '100%',
                        display: 'block',
                        borderRadius: '0.9rem',
                        objectFit: 'cover'
                    });
                    $figure.append($image);
                    $body.append($figure);
                }

                if (bodyHtml.trim() !== '') {
                    $body.append($('<div></div>').html(bodyHtml));
                }

                $target.append($body);
                return this;
            },

            reconfigure: function (nextOptions) {
                if (nextOptions && typeof nextOptions === 'object') {
                    var current = this.settings || createSettings(this.selector, {});
                    var merged = Object.assign({}, current, nextOptions);
                    if (current.requestPayload && typeof current.requestPayload === 'object' && nextOptions.requestPayload && typeof nextOptions.requestPayload === 'object') {
                        merged.requestPayload = Object.assign({}, current.requestPayload, nextOptions.requestPayload);
                    }
                    merged.prefix = sanitizePrefix(merged.prefix, this.selector);
                    this.settings = merged;
                }
                return this;
            },

            normalize: function (value) {
                return (value || '').toString().toLowerCase().trim();
            },

            mount: function () {
                if (this.destroyed === true) {
                    this.destroyed = false;
                }

                if (!this.selector) {
                    this.mounted = false;
                    return this;
                }

                if (typeof window.$ !== 'function') {
                    this.mounted = false;
                    return this;
                }

                this.$container = $(this.selector).first();
                if (!this.$container.length) {
                    this.mounted = false;
                    this.$nav = null;
                    this.$content = null;
                    this.$filter = null;
                    return this;
                }

                this.$nav = this.$container.find('[data-role="docs-nav"]').first();
                this.$content = this.$container.find('[data-role="docs-content"]').first();
                this.$filter = this.$container.find('[data-role="docs-filter"]').first();

                var isMonolithic = this.settings.viewMode === 'monolithic';
                if (!this.$content.length) {
                    this.mounted = false;
                    return this;
                }
                if (!isMonolithic && !this.$nav.length) {
                    this.mounted = false;
                    return this;
                }

                this._filterNs = '.docsrender_' + sanitizePrefix(this.selector, this.settings.prefix || 'docs');
                if (!isMonolithic) {
                    this.bindFilter();
                }
                this.mounted = true;
                return this;
            },

            bindFilter: function () {
                if (!this.$filter || !this.$filter.length) {
                    return this;
                }
                var self = this;
                var ns = this._filterNs || '.docsrender';
                this.$filter.off('input' + ns);
                this.$filter.on('input' + ns, function () {
                    self.applyFilter();
                });
                return this;
            },

            unbindFilter: function () {
                if (this.$filter && this.$filter.length) {
                    var ns = this._filterNs || '.docsrender';
                    this.$filter.off('input' + ns);
                }
                return this;
            },

            setLoading: function (isLoading) {
                this.loading = !!isLoading;
                if (!this.$content || !this.$content.length) {
                    return this;
                }
                if (this.loading && !this.loaded) {
                    this.$content.html('<div class="text-muted py-3">' + this.settings.loadingText + '</div>');
                }
                return this;
            },

            showError: function (message) {
                if (this.$nav && this.$nav.length) {
                    this.$nav.empty();
                }
                if (this.$content && this.$content.length) {
                    this.$content.html('<div class="text-danger py-3">' + message + '</div>');
                }
                return this;
            },

            activateFirstVisibleTab: function () {
                if (!this.$nav || !this.$nav.length) {
                    return this;
                }

                var $visibleButtons = this.$nav
                    .find('.nav-item:not(.d-none) button.nav-link')
                    .filter(function () {
                        return !this.hasAttribute('hidden') && this.getAttribute('aria-disabled') !== 'true';
                    });

                if (!$visibleButtons.length) {
                    return this;
                }

                var $activeVisible = $visibleButtons.filter('.active').first();
                if ($activeVisible.length) {
                    return this;
                }

                var firstVisible = $visibleButtons.first()[0];
                if (!firstVisible) {
                    return this;
                }

                if (typeof window.bootstrap !== 'undefined' && window.bootstrap && window.bootstrap.Tab) {
                    try {
                        var tab = (typeof window.bootstrap.Tab.getOrCreateInstance === 'function')
                            ? window.bootstrap.Tab.getOrCreateInstance(firstVisible)
                            : new window.bootstrap.Tab(firstVisible);
                        if (tab && typeof tab.show === 'function') {
                            tab.show();
                            return this;
                        }
                    } catch (error) {
                        // fallback below
                    }
                }

                var targetSelector = String(firstVisible.getAttribute('data-bs-target') || '').trim();
                this.$nav.find('button.nav-link.active').removeClass('active').attr('aria-selected', 'false');
                $(firstVisible).addClass('active').attr('aria-selected', 'true');
                if (targetSelector && this.$content && this.$content.length) {
                    this.$content.find('.tab-pane').removeClass('show active');
                    this.$content.find(targetSelector).addClass('show active');
                }

                return this;
            },

            applyFilter: function () {
                if (!this.$filter || !this.$filter.length || !this.$nav || !this.$nav.length) {
                    return this;
                }

                var query = this.normalize(this.$filter.val());
                var $items = this.$nav.find('.nav-item');

                $items.each(function () {
                    var $item = $(this);
                    var $button = $item.find('button.nav-link').first();
                    var label = (($button.attr('data-doc-label') || $button.text()) || '').toString().toLowerCase().trim();
                    var visible = (query === '' || label.indexOf(query) !== -1);
                    $item.toggleClass('d-none', !visible);
                });

                this.activateFirstVisibleTab();
                return this;
            },

            renderTabs: function (response) {
                var chapters = (response && response.chapters) ? response.chapters : [];
                this.responseCache = response || { chapters: [] };
                this.loaded = true;

                if (!this.$nav || !this.$nav.length || !this.$content || !this.$content.length) {
                    return this;
                }

                this.$nav.empty();
                this.$content.empty();

                if (!chapters.length) {
                    this.$content.html('<div class="text-muted py-3">' + this.settings.emptyText + '</div>');
                    return this;
                }

                var prefix = sanitizePrefix(this.settings.prefix, this.selector);
                for (var i = 0; i < chapters.length; i++) {
                    var chapter = chapters[i] || {};
                    var isActive = (i === 0);
                    var chapterKey = (chapter.chapter != null) ? chapter.chapter : (i + 1);
                    var chapterId = prefix + '-chapter-' + String(chapterKey).replace(/[^a-z0-9_-]+/gi, '-');
                    var label = this.buildChapterLabel(chapter, chapterKey);
                    var hasChapterBody = ((typeof chapter.body === 'string') && chapter.body.trim() !== '')
                        || this.getChapterMediaUrl(chapter) !== '';

                    var $navItem = $('<li class="nav-item" role="presentation"></li>');
                    var $button = $('<button class="nav-link" type="button" role="tab"></button>');
                    if (isActive) {
                        $button.addClass('active').attr('aria-selected', 'true');
                    } else {
                        $button.attr('aria-selected', 'false');
                    }
                    $button.attr({
                        id: chapterId + '-tab',
                        'data-bs-toggle': 'tab',
                        'data-bs-target': '#' + chapterId + '-pane',
                        'aria-controls': chapterId + '-pane'
                    });
                    $button.attr('data-doc-label', label);
                    $button.append(this.createLabelNode(label, chapter, {
                        iconSize: '1.6rem',
                        gap: '0.6rem'
                    }));
                    $navItem.append($button);
                    this.$nav.append($navItem);

                    var $pane = $('<div class="tab-pane fade p-1"></div>');
                    if (isActive) {
                        $pane.addClass('show active');
                    }
                    $pane.attr({
                        id: chapterId + '-pane',
                        role: 'tabpanel',
                        'aria-labelledby': chapterId + '-tab',
                        tabindex: i
                    });

                    var $heading = $('<h5></h5>');
                    $heading.append(this.createLabelNode(label, chapter));
                    $pane.append($heading);

                    this.appendChapterBody($pane, chapter, 'p-2');

                    if (Array.isArray(chapter.subchapters) && chapter.subchapters.length) {
                        for (var s = 0; s < chapter.subchapters.length; s++) {
                            var sub = chapter.subchapters[s] || {};
                            var subKey = (sub.subchapter != null) ? sub.subchapter : (s + 1);
                            var subLabel = this.settings.subLabel + ' ' + chapterKey + '.' + subKey;
                            if (sub.title) {
                                subLabel += ' - ' + sub.title;
                            }
                            var $block = $('<div class="mt-4"></div>');
                            $block.append($('<h6 class="fw-semibold"></h6>').text(subLabel));
                            if (sub.body) {
                                $block.append($('<div class="p-2"></div>').html(sub.body));
                            }
                            $pane.append($block);
                        }
                    }

                    if (!hasChapterBody && (!Array.isArray(chapter.subchapters) || chapter.subchapters.length === 0)) {
                        $pane.append('<div class="text-muted py-3">' + this.settings.emptyText + '</div>');
                    }

                    this.$content.append($pane);
                }

                this.applyFilter();
                return this;
            },

            renderMonolithic: function (response) {
                var chapters = (response && response.chapters) ? response.chapters : [];
                this.responseCache = response || { chapters: [] };
                this.loaded = true;

                if (!this.$content || !this.$content.length) {
                    return this;
                }

                this.$content.empty();

                if (!chapters.length) {
                    this.$content.html('<div class="text-muted py-3">' + this.settings.emptyText + '</div>');
                    return this;
                }

                for (var i = 0; i < chapters.length; i++) {
                    var chapter = chapters[i] || {};
                    var chapterKey = (chapter.chapter != null) ? chapter.chapter : (i + 1);
                    var label = this.buildChapterLabel(chapter, chapterKey);

                    var $section = $('<section class="docs-monolithic-chapter mb-5"></section>');
                    var $title = $('<h2 class="h4 mb-3 border-bottom pb-2"></h2>');
                    $title.append(this.createLabelNode(label, chapter, {
                        iconSize: '2.8rem',
                        gap: '0.85rem'
                    }));
                    $section.append($title);

                    this.appendChapterBody($section, chapter, 'p-2 mb-2');

                    if (Array.isArray(chapter.subchapters) && chapter.subchapters.length) {
                        for (var s = 0; s < chapter.subchapters.length; s++) {
                            var sub = chapter.subchapters[s] || {};
                            var subKey = (sub.subchapter != null) ? sub.subchapter : (s + 1);
                            var subLabel = this.settings.subLabel + ' ' + chapterKey + '.' + subKey;
                            if (sub.title) {
                                subLabel += ' - ' + sub.title;
                            }
                            var $block = $('<div class="mt-4"></div>');
                            $block.append($('<h3 class="h5 fw-semibold"></h3>').text(subLabel));
                            if (sub.body) {
                                $block.append($('<div class="p-2"></div>').html(sub.body));
                            }
                            $section.append($block);
                        }
                    }

                    this.$content.append($section);
                }

                return this;
            },

            load: function (opts) {
                var cfg = (opts && typeof opts === 'object') ? opts : {};
                var force = cfg.force === true;
                var payload = (cfg.payload && typeof cfg.payload === 'object')
                    ? cfg.payload
                    : (this.settings.requestPayload || {});

                this.mount();
                if (!this.mounted) {
                    return Promise.resolve(this);
                }

                if (!this.settings.url) {
                    this.showError(this.settings.errorText);
                    return Promise.resolve(this);
                }

                if (!force && this.loaded && this.settings.cacheResponse !== false && this.responseCache) {
                    var cachedRender = (this.settings.viewMode === 'monolithic') ? 'renderMonolithic' : 'renderTabs';
                    this[cachedRender](this.responseCache);
                    return Promise.resolve(this);
                }

                var requestApi = resolveRequestApi();
                if (!requestApi) {
                    this.showError(getRequestUnavailableMessage());
                    return Promise.resolve(this);
                }

                var self = this;
                this.requestId += 1;
                var currentRequestId = this.requestId;
                this.setLoading(true);

                var renderMethod = (self.settings.viewMode === 'monolithic') ? 'renderMonolithic' : 'renderTabs';
                return requestApi.http.post(this.settings.url, payload).then(function (response) {
                    if (self.destroyed === true || currentRequestId !== self.requestId) {
                        return self;
                    }
                    self.setLoading(false);
                    self[renderMethod](response);
                    return self;
                }).catch(function (error) {
                    if (self.destroyed === true || currentRequestId !== self.requestId) {
                        return self;
                    }
                    self.setLoading(false);
                    self.showError(getErrorMessage(error, self.settings.errorText));
                    return self;
                });
            },

            refresh: function () {
                return this.load({ force: true });
            },

            destroy: function () {
                this.unbindFilter();
                this.$nav = null;
                this.$content = null;
                this.$filter = null;
                this.$container = null;
                this.mounted = false;
                this.destroyed = true;
                this.loading = false;
                this.requestId += 1;
                if (registry && this.selector && registry[this.selector] === this) {
                    delete registry[this.selector];
                }
                return this;
            },

            unmount: function () {
                this.unbindFilter();
                this.$nav = null;
                this.$content = null;
                this.$filter = null;
                this.$container = null;
                this.mounted = false;
                return this;
            }
        };

        return instance;
    }

    var selector = normalizeSelector(containerSelector);
    if (!selector) {
        return null;
    }

    var instance = registry[selector];
    if (!instance || typeof instance !== 'object') {
        instance = createInstance(selector, options || {});
        registry[selector] = instance;
    } else {
        instance.reconfigure(options || {});
    }

    instance.mount();
    instance.load();
    return instance;
}

if (typeof window !== 'undefined') {
    window.DocsRender = DocsRender;
}
